import axios, { AxiosResponse, AxiosError } from 'axios';
import constants from 'app/constants';

import * as Sentry from '@sentry/react';

axios.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error: AxiosError) => {
    console.log('CAPTURING SENTRY ERROR');
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      Sentry.captureException(error.response.data);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      Sentry.captureException(error.message);
    }
    Sentry.captureException(error);
    return Promise.reject(error);
  },
);

const buildHeaders = config => {
  const requestHeaders = {
    'Content-Type': config.contentType ?? 'application/json',
    'X-AUTH-TOKEN': config.auth_token, // Uncomment or modify to test 401
  };

  return requestHeaders;
};

const buildUrl = url => {
  return `${constants.env.REACT_APP_KAPI_URL}${url}`;
};

export const get = async (url, config) => {
  // TODO: handle additional config
  const headers = buildHeaders(config);
  const params = config?.urlParams;
  return axios.get(buildUrl(url), { headers, params });
};

export const patch = async (url, data, config) => {
  // TODO: handle additional config
  const headers = buildHeaders(config);
  return axios.patch(buildUrl(url), JSON.stringify({ data }), {
    headers,
  });
};

export const put = async (url, data, config) => {
  // TODO: handle additional config
  const headers = buildHeaders(config);
  return axios.put(buildUrl(url), JSON.stringify({ data }), {
    headers,
  });
};

export const post = async (url, data, config) => {
  // TODO: handle additional config
  const headers = buildHeaders(config);
  return axios.post(buildUrl(url), JSON.stringify({ data }), {
    headers,
  });
};

// base64 data is already in body string format
export const postBase64 = async (url, data, config) => {
  // TODO: handle additional config
  const headers = buildHeaders(config);
  return axios.post(buildUrl(url), data, {
    headers,
  });
};

export const del = async (url, config) => {
  // TODO: handle additional config
  const headers = buildHeaders(config);
  return axios.delete(buildUrl(url), {
    headers,
  });
};
